import Pqp from "./Pqp";

export default class AnimatedText {
	constructor(mc, startDelay) {
		this.startDelay = startDelay;
		this.mc = mc;
		this.originalHtml = this.mc.html();
		this.idtos = new Array();
		this.mc.css("opacity",1);
		this.totalDelay = 0;
	}
	destroy() {
		for (let x=0;x<this.idtos.length;x++){
			clearTimeout(this.idtos[x]);
		}
		this.idtos = new Array();
		this.mc.html(this.originalHtml)
	}

	init() {
		// Tokenizza
		let tokens = this.clean(this.mc.html()).split(" ");
		let result = "";
		for (let x = 0; x < tokens.length; x++) {
			let el;
			if (tokens[x].indexOf("<br>") >= 0) {
				let tmp = Pqp.safeReplace(tokens[x], "<br>", "");
				el = "<span>" + tmp + "</span><br>";
			} else {
				el = "<span>" + tokens[x] + " </span>";
			}
			result += el;
		}
		this.mc.html(result)
		// Analizza e trova la linee
		let spans = jQuery("span", this.mc);
		let posy = -1;
		let lines = new Array();
		let line = ""
		for (let x = 0; x < spans.length; x++) {
			if (posy === -1) {
				posy = jQuery(spans[x]).offset().top;
			}
			let posEl = jQuery(spans[x]).offset().top;
			if (posy != posEl) {
				posy = posEl;
				lines.push(jQuery.trim(line));
				line = jQuery(spans[x]).text();
			} else {
				line += jQuery(spans[x]).text();
			}
		}
		lines.push(line);
		// Riscrive le linee
		let final = "";
		for (let x = 0; x < lines.length; x++) {
			let line = "<div class='txt-to-animate txt-to-animate-" + x + "'>" + lines[x] + "</div>"
			final += line;
		}
		//
		this.mc.html(final)
		// Le anima
		let divs = jQuery("div", this.mc);
		let n = 100;
		let c = 1;
		//for (let x = 0; x < divs.length; x++) {
		let delay;
		for (let x = divs.length-1; x >=0 ; x--) {
			let el = jQuery(divs[x])
			el.removeClass("openDownLeftReturn");
			el.css("opacity", 0);
			//let idto = setTimeout(this.animateLine.bind(this, el, x === divs.length - 1), n + x * 50 + this.startDelay);
			//let delay = n + x * 50 + this.startDelay;
			delay = 150*c+ this.startDelay 
			//console.log(delay)
			c++;
			//let idto = setTimeout(this.animateLine.bind(this, el, x === divs.length - 1), delay);
			let idto = setTimeout(this.animateLine.bind(this, el, x === 0), delay);
			this.idtos.push(idto);
		}
		this.totalDelay = delay;
	}

	animateLine(el, last) {

		el.addClass("openDownLeftReturn");
		if (last) {
			TweenMax.to(el, 0.5, {
				opacity: 1,
				onComplete: this.resetText.bind(this)
			});

		} else {
			TweenMax.to(el, 0.5, {
				opacity: 1
			});

		}

	}

	resetText() {
		this.mc.html(this.originalHtml)

	}

	clean(s) {
		s = Pqp.safeReplace(s, "\t", "")
		s = Pqp.safeReplace(s, "\n", "")
		s = Pqp.safeReplace(s, "<br>", "<br> ")
		return s;
	}

}